import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import z from "zod"
import { ShareDocumentDialog } from "../../-components/share-document-dialog"
import { useDocumentsSelectionContext } from "../route"

const searchSchema = z.object({
  ids: z.preprocess(
    (value) =>
      Array.isArray(value) ? value : value === undefined ? undefined : [value],
    z.array(z.string().uuid()).catch([]),
  ),
})

export const Route = createFileRoute("/_layout/documents/_list/share/bulk")({
  component: ShareDocumentsBulkModal,
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: ({ search }) => {
    if (search.ids.length === 0) {
      throw redirect({ to: "/documents", search: true })
    }
  },
})

function ShareDocumentsBulkModal(): React.ReactElement {
  const { ids } = Route.useSearch()
  const navigate = useNavigate()
  const { clearDocumentSelection } = useDocumentsSelectionContext()

  return (
    <ShareDocumentDialog
      documentIds={ids}
      onClose={() => navigate({ to: "/documents", search: true })}
      onShared={clearDocumentSelection}
    />
  )
}
